import React from "react";
import { Button } from "react-bootstrap";
import { Pencil } from "react-bootstrap-icons";

export default function EditButton(props: any) {

    let { onClick } = props;

    return (
        <Button
            variant='outline-primary'
            size='sm'
            onClick={(event) => { onClick?.(event) }}>
            <Pencil />
        </Button>
    );
}